<script>
export default {
    name: "LoginVerification",
    props: {
        verificationData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            verify_type: 'email'
        };
    },
    methods: {
        sendVerificationCode() {
            this.$emit('sendVerificationCode', this.verify_type)
        }
    }
}
</script>

<template>
    <form
        class="mb-10"
        @submit.prevent="() => {}"
    >
        <h5 class="text-center font-weight-normal">
            2 Step Verification
        </h5>
        <p class="text-secondary text-center font-weight-normal">
            Where to do you want us to send the verification code?
        </p>
        <div>
            <div class="d-flex align-items-center mt-3">
                <label class="checkbox-custom white">
                    <input type="radio" v-model="verify_type" value="email" :checked="verify_type === 'email'" />
                    <span class="checkmark-new"></span>
                </label>
                <p class="text-credit ml-1 mt-1" style="cursor: pointer" @click="verify_type = 'email'">
                    Email:
                    <strong>
                        {{ verificationData.email }}
                    </strong>
                </p>
            </div>
            <div class="d-flex align-items-center mt-3">
                <label class="checkbox-custom white">
                    <input type="radio" v-model="verify_type" value="phone" :checked="verify_type === 'phone'" />
                    <span class="checkmark-new"></span>
                </label>
                <p class="text-credit ml-1 mt-1" style="cursor: pointer" @click="verify_type = 'phone'">
                    Phone:
                    <strong>
                        {{ verificationData.phone_num }}
                    </strong>
                </p>
            </div>
        </div>

        <button
            class="btn-dialog btn-sm ok-btn w-100 mt-5"
            @click="sendVerificationCode"
        >
            SEND VERIFICATION CODE
        </button>
    </form>
</template>

<style scoped lang="scss">
    .checkbox-custom.white .checkmark-new {
        background: #fff;
        border:1px solid #e5e5e5 !important;
    }
    .checkbox-custom.white .checkmark-new:after {
        top: 2px;
        left: 1px;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        background: #313131;
    }
</style>
